"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductdetailRequest = void 0;
var ProductdetailRequest = /** @class */ (function () {
    function ProductdetailRequest() {
    }
    return ProductdetailRequest;
}());
exports.ProductdetailRequest = ProductdetailRequest;
;
//# sourceMappingURL=productdetail.request.js.map